import {storageService} from "@/container";
import {InternalAxiosRequestConfig} from "axios";

export default {
    async success(config: InternalAxiosRequestConfig) {
        const token = await storageService().read('token');

        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;

        return config;
    }
};
